export default __webpack_public_path__ + "static/media/terminos.1f7a84c7.png";